import React, { useEffect, useState, useRef } from 'react';
import { DropdownButton, Dropdown, ButtonGroup, OverlayTrigger, Popover } from 'react-bootstrap';

import draftIcon from "../../../assets/images/draft_icon.png";
import reviewIcon from "../../../assets/images/review_icon.png";
import publishedIcon from "../../../assets/images/published_icon.png";
import rejectedIcon from "../../../assets/images/rejected_icon.png";
import mergedIcon from "../../../assets/images/merged_icon_default.svg";
import disabledIcon from "../../../assets/images/disabled_icon.png";

const PatternStateDropdown = ({ patternStateId, onStateChange, hasMerged, setHasMerged = () => {}, hideMerged = false }) => {
    let pattern_states_array = [
        {
            state_id: 1,
            state_image: (<img className="state-icon Draft align-self-right" src={draftIcon} alt="Draft" />),
            state_text: "Draft",
            state_description: "This pattern is in the draft state. Only you can see this pattern."
        },
        {
            state_id: 2,
            state_image: (<img className="state-icon Review" src={reviewIcon} alt="In Review" />),
            state_text: "Review",
            state_description: "This pattern is in the review state. Anyone can look at review patterns and vote to publish them."
        },
        {
            state_id: 3,
            state_image: (<img className="state-icon Published" src={publishedIcon} alt="Published" />),
            state_text: "Published",
            state_description: "This pattern is in the published state. Everyone can see this pattern."
        },
        {
            state_id: 5,
            state_image: (<img className="state-icon Merged" src={mergedIcon} alt="Merged" />),
            state_text: "Merged",
            state_description: <>{`${hasMerged ? "This pattern is in the merged state. The contents of this pattern were combined with another pattern to form a new pattern with the best aspects of both." : ''}` +
                `${hasMerged ? ' This pattern will be sorted to the bottom of all patterns when sorting by rating unless you change the state and update the pattern.' : ''}` +
                `${!hasMerged ? 'Click to merge this pattern with another pattern. After the merge:' : ''}`}
                {!hasMerged && <ul style={{marginLeft: 5, paddingLeft: 25, paddingBottom: 0, marginBottom: 0}}>
                    <li>The original patterns will be hidden.</li>
                    <li>A new combined pattern will be created.</li>
                </ul>}
            </>
        },
        {
            state_id: 4,
            state_image: (<img className="state-icon Rejected" src={rejectedIcon} alt="Rejected" />),
            state_text: "Rejected",
            state_description: "This pattern is in the draft state. Only you can see this pattern. Only a design leader or instructor can mark a pattern as rejected."
        },
        {
            state_id: 6,
            state_image: (<img className="state-icon Disabled" src={disabledIcon} alt="Disabled" />),
            state_text: "Disabled",
            state_description: "This pattern is in the disabled state. Only you can see this pattern."
        }
    ];

    if (hideMerged) {
        pattern_states_array = pattern_states_array.filter((item) => item.state_id !== 5);
    }

    // I am using this to stop the dropdown resetting to merged state after clicking on another state.
    // Before I would click on the dropdown and select the draft state. The displayed state would switch right back to
    // the merged state. No it doesn't.
    const noSelectionMade = useRef(true);

    const [current_state_array_index, set_current_state_array_index] = useState(0);

    useEffect(() => {
        if (noSelectionMade.current && hasMerged && pattern_states_array && !hideMerged) {
            set_current_state_array_index(pattern_states_array.findIndex((i) => i.state_id === 5));
        } else if (pattern_states_array && !hasMerged) {
            set_current_state_array_index(pattern_states_array.findIndex((i) => i.state_id === patternStateId))
        }
    }, [hasMerged, pattern_states_array, hideMerged, patternStateId]);

    const renderPatternState = (state) => (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement='right'
            overlay={
                <Popover id='pattern-exercise-description'>
                    <Popover.Title as="h3">{state.state_text}</Popover.Title>
                    <Popover.Content>{state.state_description}</Popover.Content>
                </Popover>
            }
        >
            {state.state_image}
        </OverlayTrigger>
    );

    return (
        <div className="state-dropdown align-self-left">
            <DropdownButton
                as={ButtonGroup}
                key="state_dropdown"
                id="dropdown-button"
                drop="down"
                variant="secondary"
                title={renderPatternState(pattern_states_array[current_state_array_index])}
                onSelect={(eventKey) => {
                    noSelectionMade.current = false
                    const selectedStateIndex = eventKey - 1;
                    set_current_state_array_index(selectedStateIndex);
                    onStateChange(pattern_states_array[selectedStateIndex].state_id);
                    if (hasMerged) {
                        //sets to false
                        setHasMerged()
                    }
                }}
            >
                {pattern_states_array.map((state, index) => (
                    <Dropdown.Item key={index + 1} eventKey={index + 1}>
                        {renderPatternState(state)}
                    </Dropdown.Item>
                ))}
            </DropdownButton>
        </div>
    );
};

export default PatternStateDropdown;
